import { render, staticRenderFns } from "./PageMenu.vue?vue&type=template&id=02e15066&scoped=true"
import script from "./PageMenu.vue?vue&type=script&lang=js"
export * from "./PageMenu.vue?vue&type=script&lang=js"
import style0 from "./PageMenu.vue?vue&type=style&index=0&id=02e15066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e15066",
  null
  
)

export default component.exports